//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import jsonEdit from '@/components/jsonEdit/index.vue';

export default {
  name: 'InputJson',
  components: { jsonEdit },
  model: {
    props: 'value',
    event: 'update',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showJson: false,
      oldJson: '',
    };
  },
  methods: {
    openJsonEdit() {
      this.oldJson = this.value;
      this.$nextTick(() => {
        this.showJson = true;
      });
    },
  },
};
